<template>
  <b-row align-h="center">
    <b-col lg="6" class="form">
      <h3 class="mb-4">Participant Form</h3>
      <b-row>
        <b-col lg="6"
          ><b-form-group
            id="form-group"
            label="Name"
            label-for="form-group__name"
          >
            <b-form-input
              id="form-group__name"
              v-model="name"
              trim
            ></b-form-input> </b-form-group
        ></b-col>
        <b-col lg="6">
          <b-form-group
            id="form-group"
            label="Location"
            label-for="form-group__location"
          >
            <b-form-input
              id="form-group__location"
              v-model="location"
              type="text"
              trim
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col lg="12"
          ><b-form-group
            id="form-group"
            label="Participant Type"
            label-for="form-group__type"
          >
            <b-form-select
              v-model="type"
              :options="options"
            ></b-form-select> </b-form-group
        ></b-col>

        <b-col lg="12"
          ><b-form-group
            id="form-group"
            label="Address"
            label-for="form-group__address"
          >
            <b-form-input
              id="form-group__address"
              v-model="accounts"
              disabled
              trim
            ></b-form-input> </b-form-group
        ></b-col>
      </b-row>
      <b-row>
        <b-col lg="4" class="mx-auto"
          ><b-button variant="primary" @click="submit" :disabled="isDisabled"
            >Submit Form</b-button
          ></b-col
        >
      </b-row>
    </b-col>
    <Decode
      :isVisible="isVisible"
      @clicked="child_passphrase"
      @redirect="child_redirect"
    />
  </b-row>
</template>

<script>
import { mapState, mapActions } from 'vuex'
// import { getPrivKey } from '@/utils/getPrivKey'
import { signAndSendTransaction } from '@/ethereum/send'
import Decode from '@/components/modal/Decode.vue'
import CryptoJS from 'crypto-js'
// import web3 from '@/web3'

export default {
  components: {
    Decode
  },
  computed: {
    ...mapState(['contracts'])
  },
  data() {
    return {
      name: '',
      location: '',
      type: null,
      options: [
        { value: null, text: 'Please select an option.' },
        { value: 'Manufacturer', text: 'Manufacturer' },
        { value: 'Supplier', text: 'Supplier' },
        { value: 'Consumer', text: 'Consumer' },
        { value: 'Distributor', text: 'Distributor' },
        { value: 'Retailer', text: 'Retailer' }
      ],
      isDisabled: false,
      isVisible: false,
      passphrase: '',
      accounts: sessionStorage.getItem('address')
    }
  },
  async mounted() {
    try {
      const { contracts, accounts } = this

      if (!accounts) return

      const result = await contracts.Proxy.methods
        .participants(accounts)
        .call({ from: accounts })

      if (!result) {
        this.isDisabled = true
        return
      }

      this.name = result.name || ''
      this.location = result.location || ''
      this.type = result.participantType || null

      // let nonce = await web3.utils.toHex(
      //   web3.eth.getTransactionCount(accounts, 'pending')
      // )
      // console.log('Nonce Count : ', nonce)
      // console.log(
      //   'Nonce Count number : ',
      //   await web3.eth.getTransactionCount(accounts, 'pending')
      // )
      // if (result.participantAddress === this.accounts) this.isDisabled = true
    } catch (error) {
      console.log('Error :', error)
    }
  },
  methods: {
    ...mapActions(['init_notification']),
    submit: async function() {
      try {
        const { passphrase, name, location, type, accounts } = this

        if (!passphrase) {
          this.isVisible = true
          return
        }

        this.isDisabled = !this.isDisabled

        let result = await this.contracts.Implementation.methods.createParticipant(
          name,
          location,
          accounts,
          type
        )

        let decrypted = CryptoJS.AES.decrypt(
          sessionStorage.getItem('private_key'),
          this.passphrase
        )

        const acc = decrypted.toString(CryptoJS.enc.Utf8)
        const response = await signAndSendTransaction(result, acc)

        if (response) {
          this.isDisabled = !this.isDisabled
          this.init_notification({
            isVisible: true,
            header: 'Participant registered with transaction hash of',
            body: ` ${response.transactionHash}`
          })
        }
      } catch (error) {
        console.log('Catched Error : ', error)
      }
    },
    child_passphrase: function(value) {
      try {
        let decrypted = CryptoJS.AES.decrypt(
          sessionStorage.getItem('private_key'),
          value
        )

        if (
          decrypted.toString(CryptoJS.enc.Utf8) === '' ||
          decrypted.toString(CryptoJS.enc.Utf8).length === 0
        )
          return alert('Invalid passphrase')

        this.passphrase = value
        this.isVisible = false
      } catch (error) {
        const { message } = error

        if (message === 'ciphertext is null')
          return console.log('Encrypted value is null')
      }
    },
    child_redirect: function(path) {
      this.$router.push(path)
    }
  }
}
</script>

<style scoped>
.form.col-lg-6 {
  padding: 20px 50px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 7px 23px #88888852;
  border-radius: 12px;
}

.form-group {
  margin-bottom: 1rem;
}
</style>
